import React, { useEffect } from "react";
import { NavLink, useHistory, useLocation } from "react-router-dom"; // Use `useHistory` for v5
import { FieldArray, Field, Form, useFormikContext } from "formik";
import { useCoursesContext } from "./CourseProvider";

const GulfCourse = ({ index, remove,courseId }) => {
  const { setFieldValue, values } = useFormikContext();
  const { onClickScroll } = useCoursesContext();
 const role = localStorage.getItem("userRole");
const isSuperAdmin = (role || "").toLowerCase() === "superadmin";

  const handleDelete = () => remove(index);

  const handleScrollAndSetActive = (action) => {
    console.log(courseId,"courseid");
    
        localStorage.setItem("selectedLiveCourseId", courseId);

    setFieldValue("activeCourseIndex", index);
    onClickScroll(index);
    console.log(index,"index")
    action();
  };

  return (
    <div className="acccore__box__sec2">
      <Field
        className="acc__input-lg"
        type="text"
        placeholder="Wentworth Course 1"
        name={`data[${index}].course_name`}
        readOnly
      />

      <NavLink to="/courses-map-courses">
        <span
          className="acccore__box__sec2-link"
          onClick={() => handleScrollAndSetActive(() => {})}
        >
          MAP THIS COURSE
        </span>
      </NavLink>

      <div className="custom-select-wrapper">
        <Field
          className="acc__input-lg"
          type="text"
          placeholder="NUMBER OF HOLES"
          name={`data[${index}].total_holes`}
          readOnly
        />
      </div>

      <NavLink to="/courses-map-courses/hole">
        <span
          className="acccore__box__sec2-link order_4"
          onClick={() => handleScrollAndSetActive(() => {})}
        >
          HOLE TIMES
        </span>
      </NavLink>

      <NavLink to="/courses-map-courses/hole-detail">
        <span
          className="acccore__box__sec2-link order_5"
          onClick={() => handleScrollAndSetActive(() => {})}
        >
          Yards & Par
        </span>
      </NavLink>
{isSuperAdmin && (
        <NavLink to="/courses-live-view">
          <span
            className="acccore__box__sec2-link order_6"
            onClick={() => handleScrollAndSetActive(() => {})}
          >
            Live View
          </span>
        </NavLink>
      )}
      {values?.data?.length > 1 && (
        <button onClick={handleDelete} type="button">
          <img
            src={require("../../../assets/images/del/delete.svg").default}
            alt="delete icon"
          />
        </button>
      )}
    </div>
  );
};

const AddCourses = () => {
  const { fetchCourses } = useCoursesContext();
  const { values } = useFormikContext();
  const history = useHistory(); // Use `useHistory` for v5
  const location = useLocation();
 // adjust key path if needed

  useEffect(() => {
    fetchCourses(location, 0);
  }, [fetchCourses, location]);

  return (
    <Form className="acccore__box">
      <div className="acccore__box__sec1">
        <h2 className="acccore__box__sec1-txt text-jost-sb-24">
          Your clubs golf courses
        </h2>
        <button
          className="res-btn-lightgrn"
          onClick={() => history.push("/courses-add-courses")} // Use `history.push` for v5
          type="button"
        >
          ADD COURSE
        </button>
      </div>

      <FieldArray name="data">
        {({ remove }) =>
          values?.data?.map((course, index) => (
            <GulfCourse key={index} index={index} remove={remove} courseId={course.id} />
          ))
        }
      </FieldArray>
    </Form>
  );
};

export default AddCourses;
